import CONSTANTS from '@/constants'

const {
  BLACK_FRIDAY_PRODUCT_BUNDLES,
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES,
  TCS_PROMO_PRODUCT_BUNDLES,
  SUMMER_SAVINGS_BUNDLE,
} = CONSTANTS
const { INE_BLACK_FRIDAY_BUNDLE_ONE, INE_BLACK_FRIDAY_BUNDLE_TWO, INE_BLACK_FRIDAY_BUNDLE_THREE } =
  BLACK_FRIDAY_PRODUCT_BUNDLES
const { INE_LEAP_YEAR_BUNDLE } = LEAP_YEAR_PROMO_PRODUCT_BUNDLES
const { INE_TCS_BUNDLE } = TCS_PROMO_PRODUCT_BUNDLES
const { INE_SUMMER_SAVINGS_BUNDLE } = SUMMER_SAVINGS_BUNDLE

export const availableProductBundlesHydratation = productBundlesCollection => {
  const BLACK_FRIDAY_BUNDLE_ONE_SAVINGS_CENTS = 74900
  const BLACK_FRIDAY_BUNDLE_TWO_SAVINGS_CENTS = 65000
  const FUNDAMENTALS_ANNUAL_ORIGINAL_PRICE_CENTS = 29900
  const renewalMessageOpt2 =
    'Your INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term. You must cancel your subscription renewal before the scheduled renewal date to avoid auto renewal and the associated renewal fee.'
  productBundlesCollection.forEach(bundle => {
    bundle.merchant_id = bundle.slug
    switch (bundle.slug) {
      case INE_BLACK_FRIDAY_BUNDLE_ONE: {
        bundle.nameToShow = 'Premium + Skill Dive + 1 INE Certification'
        bundle.name = bundle.nameToShow
        bundle.isBestValue = true
        bundle.term = 'year'
        bundle.subtitle = {
          text: 'Entire Content Library',
          color: 'var(--strong-light-green-b5)',
        }
        bundle.text = 'Entire Content Library'
        bundle.tooltip =
          'Over 3500 hours of content across  <br/>70+ learning paths for all skill levels;<br/><span style="color:#b5ffe9">Skill Dive included</span>'
        bundle.infoTitle = {
          label: '50% OFF',
          text: 'Yearly INE Certification Voucher',
        }
        bundle.buttonCtaLabel = 'Get Premium'
        bundle.user_receives_discount = true
        const discountedPriceCentsBundleOne = bundle.price_cents
        const discountedPriceBundleOne = bundle.price
        bundle.discounted_price_cents = discountedPriceCentsBundleOne
        bundle.discounted_price = discountedPriceBundleOne
        bundle.user_saves_price_cents = BLACK_FRIDAY_BUNDLE_ONE_SAVINGS_CENTS
        const originalPriceCentsBundleOne =
          discountedPriceCentsBundleOne + BLACK_FRIDAY_BUNDLE_ONE_SAVINGS_CENTS
        bundle.price_cents = originalPriceCentsBundleOne
        bundle.price = `$${(originalPriceCentsBundleOne / 100).toFixed(2)}`
        bundle.inlineSkillDiveTitle = {
          prefix: 'Premium + ',
          suffix: ' + Certification',
          label: 'Skill Dive',
        }
        bundle.link = 'https://ine.com/faqs/subscriptions/premium'
        bundle.renewalMessage =
          'Each INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term.<br/>Free INE Certification Voucher will be added to your account immediately after checkout. Voucher will expire 180 days from purchase date.'
        break
      }
      case INE_BLACK_FRIDAY_BUNDLE_TWO: {
        bundle.nameToShow = 'Premium + INE Certification'
        bundle.name = bundle.nameToShow
        bundle.term = 'year'
        bundle.subtitle = {
          text: 'Entire Content Library',
          color: 'var(--strong-light-green-b5)',
        }
        bundle.text = 'Entire Content Library'
        bundle.tooltip =
          'Over 3500 hours of content across 70+<br/>learning paths for all skill levels;<br/><span style="color:#f8b369">Skill Dive not included</span>'
        bundle.infoTitle = {
          label: '50% OFF',
          text: 'Yearly INE Certification Voucher',
        }
        bundle.buttonCtaLabel = 'Get Premium'
        bundle.user_receives_discount = true
        const discountedPriceCentsBundleTwo = bundle.price_cents
        const discountedPriceBundleTwo = bundle.price
        bundle.discounted_price_cents = discountedPriceCentsBundleTwo
        bundle.discounted_price = discountedPriceBundleTwo
        bundle.user_saves_price_cents = BLACK_FRIDAY_BUNDLE_TWO_SAVINGS_CENTS
        const originalPriceCentsBundleTwo =
          discountedPriceCentsBundleTwo + BLACK_FRIDAY_BUNDLE_TWO_SAVINGS_CENTS
        bundle.price_cents = originalPriceCentsBundleTwo
        bundle.price = `$${(originalPriceCentsBundleTwo / 100).toFixed(2)}`
        bundle.link = 'https://ine.com/faqs/subscriptions/premium'
        bundle.renewalMessage =
          'Each INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term.<br/>Free INE Certification Voucher will be added to your account immediately after checkout. Voucher will expire 180 days from purchase date.'
        break
      }
      case INE_BLACK_FRIDAY_BUNDLE_THREE:
        bundle.nameToShow = 'Fundamentals Annual'
        bundle.name = 'Fundamentals Annual'
        bundle.term = 'year'
        bundle.subtitle = {
          text: 'Limited Introductory Content',
          color: 'var(--light-orange)',
        }
        bundle.text = 'Limited Introductory Content'
        bundle.tooltip = 'Over 200 hours of novice level<br/>content across 7 learning paths'
        bundle.infoTitle = {
          label: 'FREE',
          text: 'eJPT + ICCA Vouchers',
        }
        bundle.user_receives_discount = true
        bundle.discounted_price_cents = bundle.price_cents
        bundle.discounted_price = bundle.price
        bundle.user_saves_price_cents =
          FUNDAMENTALS_ANNUAL_ORIGINAL_PRICE_CENTS - bundle.discounted_price_cents
        bundle.original_price_cents = FUNDAMENTALS_ANNUAL_ORIGINAL_PRICE_CENTS
        bundle.original_price = `$${FUNDAMENTALS_ANNUAL_ORIGINAL_PRICE_CENTS / 100}.00`
        bundle.price_cents = FUNDAMENTALS_ANNUAL_ORIGINAL_PRICE_CENTS
        bundle.price = bundle.original_price
        bundle.link = 'https://ine.com/faqs/subscriptions/fundamentals'
        bundle.renewalMessage = renewalMessageOpt2
        break
      case INE_LEAP_YEAR_BUNDLE:
        bundle.nameToShow = 'Premium + 1 INE Security Certification'
        bundle.renewalMessage = renewalMessageOpt2
        break
      case INE_TCS_BUNDLE:
        Object.assign(bundle, {
          description: null,
          discounted_price: bundle.price,
          discounted_price_cents: bundle.price_cents,
          infoTitle: {
            label: 'Free',
            text: 'Annual Voucher Discount',
          },
          isBestValue: true,
          link: 'https://ine.com/faqs/subscriptions/premium',
          merchant_id: bundle.slug,
          name: 'Premium',
          nameBundle: bundle.name,
          nameToShow: 'Premium + 1 INE Security Certification',
          product_type: 'bundle',
          renewalMessage: renewalMessageOpt2,
          subtitle: { text: '3500+ Training Hours', color: 'var(--strong-light-green-b5)' },
          term: 'year',
          text: 'Entire Content Library',
          tooltip:
            'Access 3500+ hours of content across 70+ learning paths <br>for all skill levels; Skill Dive not included',
          user_receives_discount: true,
        })
        break
      case INE_SUMMER_SAVINGS_BUNDLE:
        Object.assign(bundle, {
          description: null,
          price: `$${bundle.price_cents / 100 + 500}.00`,
          price_cents: bundle.price_cents + 50000,
          discounted_price: bundle.price,
          discounted_price_cents: bundle.price_cents,
          user_saves_price_cents: 50000,
          user_receives_discount: true,
          infoTitle: {
            label: '50% OFF',
            text: 'Yearly INE Certification Voucher',
          },
          isBestValue: true,
          link: 'https://ine.com/faqs/subscriptions/premium',
          merchant_id: bundle.slug,
          name: 'Premium',
          nameBundle: bundle.name,
          nameToShow: 'Premium + 1 INE Security Certification',
          product_type: 'bundle',
          renewalMessage: renewalMessageOpt2,
          subtitle: { text: 'Entire Content Library', color: 'var(--strong-light-green-b5)' },
          term: 'year',
          text: 'Entire Content Library',
          tooltip:
            'Over 3500 hours of content across <br/>70+ learning paths for all skill levels;<br/><span style="color:#f8b369">Skill Dive not included</span>',
        })
        break
      default:
        break
    }
  })
}
